import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Waves, Compass, CalendarCheck, Headset } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { useBooking } from "../components/BookingDialog";
import Reveal from "../components/Reveal";

const ABOUT_IMG = "https://images.pexels.com/photos/28638835/pexels-photo-28638835.jpeg";

const About = () => {
  const { t } = useLang();
  const { openBooking } = useBooking();
  const whyIcons = [Waves, Compass, CalendarCheck, Headset];

  return (
    <div className="bg-[#f7f5ef] min-h-screen">
      <section className="relative pt-40 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img src={ABOUT_IMG} alt="Agadir" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-[#1c221e]/70" />
        </div>
        <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-8 text-center">
          <p className="text-white/80 text-xs tracking-[0.25em] uppercase mb-4">{t.intro.eyebrow}</p>
          <h1 className="font-serif text-5xl md:text-6xl text-white mb-6">{t.intro.title}</h1>
          <p className="text-white/85 text-lg leading-relaxed">{t.intro.text}</p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <div className="text-center mb-16">
            <p className="text-[#7c8f74] text-xs tracking-[0.25em] uppercase mb-4">{t.why.eyebrow}</p>
            <h2 className="font-serif text-4xl md:text-5xl text-[#20261f]">{t.why.title}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {t.why.items.map((item, i) => {
              const Icon = whyIcons[i];
              return (
                <Reveal key={i} delay={i * 100}>
                  <div className="text-center px-2">
                    <div className="w-16 h-16 rounded-full bg-[#7c8f74]/12 flex items-center justify-center mx-auto mb-6">
                      <Icon size={26} className="text-[#5c6b54]" strokeWidth={1.6} />
                    </div>
                    <h3 className="font-serif text-xl text-[#20261f] mb-3">{item.title}</h3>
                    <p className="text-sm text-[#6b7166] leading-relaxed">{item.text}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
          <div className="text-center mt-16">
            <button
              onClick={() => openBooking()}
              className="inline-flex items-center gap-2 bg-[#7c8f74] hover:bg-[#697c62] text-white px-10 py-4 rounded-full text-sm tracking-[0.1em] uppercase font-medium transition-all hover:-translate-y-0.5 hover:shadow-xl"
            >
              {t.ctaBand.button} <ArrowRight size={17} />
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
